export default "__VITE_ASSET__DflBT$LF__"